import React from "react";
import {saveClient,getClients,deleteClient,updateClient} from "../../services/clientService"; // ajuste o caminho
import { useCompany } from "../../contexts/CompanyContext";
import CrudTable from "../../components/Custom/CrudTable";
import { TextField } from "@mui/material";


const ClientPage = () => {
  function formatPhoneBR(phone) {
    if (!phone) return "";
    const digits = phone.replace(/\D/g, "");
    if (digits.length <= 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").trim();
    } else {
      return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").trim();
    }
  }

  const { company } = useCompany();
  
  const columns = [
    { key: "name", label: "Nome" },
    { key: "address", label: "Endereço" },
    { key: "phone", label: "Telefone", render: (value) => formatPhoneBR(value) },
    { key: "email", label: "Email" }
  ];

  const fields = [
    { name: "name", label: "Nome" },
    { name: "address", label: "Endereço" },
    { name: "phone", label: "Telefone" },
    { name: "email", label: "Email" }
  ];

  const service = {
    getAll: (companyId) => getClients(companyId),
    create: (companyId, data) => saveClient(companyId, data),
    update: (companyId, id, data) => updateClient(companyId, id, data),
    remove: (companyId, id) => deleteClient(companyId, id),
  };

  return (
    <CrudTable
      title="Clientes"
      columns={columns}
      fields={fields}
      service={service}
      entityName="cliente"
      companyId={company.companyId}
      renderForm={(selectedItem, handleChange, setSelectedItem) => (
        <>
          {fields.map((f) => (
            <TextField
              key={f.name}
              fullWidth
              margin="normal"
              type={f.type || "text"}
              label={f.label}
              name={f.name}
              value={
                f.name === "phone"
                  ? selectedItem[f.name] // ✅ deixa editar normalmente
                  : selectedItem[f.name] || ""
              }
              onChange={(e) => {
                let val = e.target.value;
                if (f.name === "phone") {
                  // ✅ aplica máscara dinamicamente
                  val = formatPhoneBR(val);
                }
                setSelectedItem((prev) => ({ ...prev, [f.name]: val }));
              }}
            />
          ))}
        </>
      )}
    />
  );
};

export default ClientPage;
